<template>
  <div
    class="realtime-video-list"
    ref="wrapper"
  >
    <div class="header">
      <div class="warp-title">
        <img src="@/assets/img/icon14.png" style="width: 20px; margin-right: 5px;"/>
        监控视频
      </div>
      <el-button type="primary" style="margin-left: 10px;" @click="showHandleSort = true">
        <img src="@/assets/img/icon18.png" style="width: 14px; margin-right: 5px;"/>
        排序
      </el-button>
    </div>
    <el-row>
      <el-col :span="isCollaps ? 24 : 24" style="overflow-x: auto">
        <div class="realtime-video-card-list">
          <div :style="{width: 400 * videoArr.length + 'px'}" v-if="videoArr.length > 0">
            <el-card shadow="never" class="box-card" v-for="(v, i) in videoArr" :key="i">
              <div slot="header" class="clearfix">
                <div>
                  <el-button type="primary" @click="showDialogHandleOutIn('showHandleIn', v.GateId, v.Direction)">开闸</el-button>
                  <el-button type="warning" @click="showDialogHandleOutIn('showHandleOut', v.GateId)">关闸</el-button>
                  <!--                    <el-button v-if="v.Direction === 2" type="primary" size="small" @click="showDialogSearchTable(v.GateId)">出口最近订单</el-button>-->
                  <el-button v-if="v.LockState === 1 && Boolean(settingConfig.LockGate)" @click="handleLock(v.GateId)">锁闸</el-button>
                  <el-button v-if="v.LockState === 2 && Boolean(settingConfig.LockGate)" @click="handleUnLock(v.GateId)">解锁</el-button>
                </div>
                <div>
                  {{ v.Name }}
                  <div class="type-list">
                    <div :class="{offline: !v.online}"><img :src="require(`@/assets/img/${v.online ? 'icon09' : 'icon15'}.png`)" style="width: 12px; height: 12px; margin-right: 3px;" v-if="type !== '逐一' && type !== '武汉'"/>{{v.online ? '相机正常' : '相机异常'}}</div>
                    <div @click="handleBig(v)"  v-if="v.Url !== '' && settingConfig.ShowVideo === 1" style="cursor: pointer;"><img :src="require(`@/assets/img/icon19.png`)" style="width: 12px; height: 12px; margin-right: 3px;"/>视频放大</div>
<!--                    <div :class="{offline: !v.gateType}"><img :src="require(`@/assets/img/${v.gateType ? 'icon10' : 'icon16'}.png`)"  style="width: 12px; height: 12px; margin-right: 3px;"/>{{v.gateType ? '道闸竖直' : '道闸异常'}}</div>-->
                  </div>
                </div>
              </div>
              <div class="video-box" v-if="settingConfig.ShowVideo === 1">
                <div v-if="v.online || type === '逐一' || type === '武汉'" style="width: 100%;">
                  <live-video
                    :ref="`video${v.Id}`"
                    :gateId="v.Id"
                    :url="v.Url"
                    class="video"
                    v-if="!v.isIframe"
                  />
                  <iframe
                    :src="v.Url"
                    scrolling="no"
                    allowfullscreen=""
                    frameborder="0"
                    height="205" width="360"
                    v-else
                  ></iframe>
                </div>
                <div class="video-off-line" v-else>
                  <img src="@/assets/img/img02.png" style="width: 128px;"/>
                  <p>{{!v.online && !v.gateType ? '数据' : '相机'}}异常</p>
                </div>
                <div class="gate-box" v-if="!v.gateTypeShow && v.online" @click="v.gateTypeShow = true">
                  <img src="@/assets/img/img10.png" style="width: 70%;"/>
                </div>
              </div>
              <div class="video-box" style="margin: 0 -10px;" v-else>
                <el-image
                    style="width: 100%; height: 225px;"
                    :src="v.liveImages[0]"
                    fit="fill"
                    :preview-src-list="v.liveImages"
                >
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                  <div slot="error" class="image-slot" style="line-height: 223px;">暂无图片</div>
                </el-image>
              </div>
            </el-card>
          </div>
          <el-row v-else>
            <el-col class="nodata-container" :style="{ height:( height-120) + 'px',}">
            <img
                class="noVideo"
                src="@/assets/img/nodata.png"
                alt=""
              />
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <dialog-handle-in v-if="showHandleIn" :showdialog.sync="showHandleIn"  :videoGateId="videoGateId" :selectDisabled="true" :titleDialog="titleDialog[direction]"/>
    <dialog-handle-out v-if="showHandleOut" :showdialog.sync="showHandleOut"  :videoGateId="videoGateId" :selectDisabled="true"></dialog-handle-out>
    <dialog-handle-sort v-if="showHandleSort" :showdialog.sync="showHandleSort"  :videoGateId="videoGateId" :selectDisabled="true"></dialog-handle-sort>
    <el-dialog
      :visible.sync="showHandleVideo"
      width="1200px"
      @close="handleBigClose"
      :append-to-body="true"
      center>
      <live-video
        :ref="`video${videoData.Id}`"
        :gateId="videoData.Id"
        :url="videoData.Url"
        class="videoDialog"
        v-if="!videoData.isIframe"
      />
      <iframe
        :src="videoData.Url"
        scrolling="no"
        allowfullscreen=""
        frameborder="0"
        height="615" width="100%"
        v-else
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
import liveVideo from "@/serviceComponents/liveVideo";
import { videoList, lockGate, unLockGate } from "@/api/module/park";
// import liveImage from "@/serviceComponents/liveImage";
// import Img from "@/assets/img/video.png";
// import { parkInPubSub, parkOutPubSub } from "@/service/pubsub/index";
import { findPassRecord } from "@/api/module/tenant";
//输入车牌号码入场  弹窗
import dialogHandleIn from "@/serviceComponents/dialogHandleIn";
import dialogHandleOut from "@/serviceComponents/dialogHandleOut";
import dialogHandleSort from "@/serviceComponents/dialogHandleSort";
import { closeGate } from "@/api/module/park";
import { voicePrompt } from '@/utils/voicePrompt'
import {
  parkOrderListPubSub,
} from "../service/pubsub/index";
import { distinguishTitle } from "@/utils/index";
import { getRoleCode, getIsSentryBoxTabs } from "@/utils/service";

export default {
  props: {
    height: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      isQuery: false,
      parkImg: "",
      plateNumber: "",
      parkLotId: "",
      park_passings_id: "",
      scrollTop: 0,
      videoArr: [],
      videoList: [],
      showHandleIn: false,
      showHandleOut: false,
      videoGateId: 0,
      titleDialog: ['', '强制入车', '强制出车', '强制开闸'],
      direction: 0,
      isOnline: false,
      showHandleSort: false,
      type: null,
      showHandleVideo: false,
      videoData: {
        Id: undefined,
        Url: undefined,
      },
    };
  },
  computed: {
    gateId: function () {
      return this.$store.state.order.gateIds;
    },
    isCollaps: function () {
      return this.$store.state.layout.isCollaps;
    },
    tenantId: function () {
      return this.$store.state.user.tenantId;
    },
    gateIdsStr: function () {
      return this.$store.state.order.gateIdsStr;
    },
    videoGateIds: function () {
      return this.$store.state.order.videoGateIds;
    },
    settingConfig: function () {
      return this.$store.state.layout.settingConfig;
    },
    isSentryBoxManager: function () {
      return this.$store.state.layout.isSentryBoxTabs ? this.$store.state.layout.isSentryBoxTabs === 'true' : getIsSentryBoxTabs() === 'true';
    },
    isSentryBox: function () {
      return getRoleCode() === 'sentryBox'
    },
    liveImages: function () {
      return this.$store.state.order.liveImages;
    }
  },
  components: {
    liveVideo,
    // liveImage,
    dialogHandleIn,
    dialogHandleOut,
    dialogHandleSort,
  },
  watch: {
    videoGateIds:{
      handler(){
        if (this.isSentryBoxManager) {
          console.log('videoGateIds')
          this.videoArr = [];
          this.videoList = [];
          this.getVideo();
        }
      },
      // 深度观察监听
      deep: true
    },
    gateIdsStr: {
      handler(){
        if (!this.isSentryBoxManager) {
          console.log('gateIdsStr')
          this.videoArr = [];
          this.videoList = [];
          this.getVideo();
        }
      },
      // 深度观察监听
      deep: true
    },
    gateId: {
      handler(){
        console.log('gateId')
        if (this.isSentryBox) {
          this.videoArr = [];
          this.videoList = [];
          this.getVideo();
        }
      },
      deep: true
    },
    $route: {
      handler: function(){
        console.log('$route')
        this.videoArr = [];
        this.videoList = [];
        this.getVideo();
      },
      deep: true
    },
    liveImages(v) {
      // console.log(JSON.parse(v), this.videoArr)
      let obj = JSON.parse(v);
      this.videoArr.forEach(v => {
        if (obj.inGateId === v.GateId) {
          v.liveImages = obj.passInFullImageArr
        }
        if (obj.outGateId === v.GateId) {
          v.liveImages = obj.passOutFullImageArr
        }
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      // parkOutPubSub.unsubscribe();
      // parkOutPubSub.subscribe(this.getOutImage);
      // parkInPubSub.unsubscribe();
      // parkInPubSub.subscribe(this.getInImage);
      this.$store.dispatch("SetInitWs", false);
      // this.getVideo();
      this.$forceUpdate();
      // setInterval(() => {
      //   this.isOnline = !this.isOnline
      //   this.videoArr = this.videoArr.map(v => {
      //     v.online = this.isOnline
      //     return v
      //   })
      // }, 1000)
      this.type = distinguishTitle();
    });
    window.onfocus=()=>{
      for(let i=0;i<this.videoArr.length;i++){
        let item='video'+this.videoArr[i].Id;
        if(this.$refs[item] && this.$refs[item][0] && this.$refs[item][0].flvPlayer){
         this.$refs[item][0].correctVideoTime()
        }
      }
    }
  },
  methods: {
    async server() {
      return new Promise((resolve) => {
        findPassRecord({ Id: Number(this.park_passings_id) }).then((res) => {
          if (res.state === "success") {
            resolve(res.data);
          } else {
            resolve({ PlateImage: "" });
          }
        });
      });
    },
    handleScroll() {
      this.scrollTop = this.$refs.wrapper.scrollTop;
    },
    getVideo() {
      this.videoList = [];
      let gateIdArr = this.isSentryBoxManager ? this.videoGateIds : JSON.parse(this.gateIdsStr);
      if (this.isSentryBoxManager && this.gateId.length > 0 && gateIdArr[0] && gateIdArr[0].online !== undefined || !this.isSentryBoxManager && this.gateId.length > 0 && gateIdArr[0] && gateIdArr[0].online !== undefined) {
        // console.log(gateIdArr)
        gateIdArr.forEach(v => {
          // console.log(v, v.online, v.gateType)
          videoList({ParkLotGateId: v.Id}).then(res => {
            // console.log(obj, res)
            if(res.data){
              res.data.forEach((vv, i)=>{
                this.setVideo({
                  GateId: v.Id,
                  Direction: v.Direction,
                  LockState: v.LockState,
                  online: v.online,
                  gateType: v.gateType,
                  gateTypeShow: v.gateType,
                  Url: vv,
                  Id: String(v.Id) + i,
                  Name: v.Name + '-' + (i + 1),
                  liveImages: [],
                  isIframe: vv.indexOf('/api/_mn_') > -1,
                });
              });
            } else {
              this.setVideo({
                GateId: v.Id,
                Direction: v.Direction,
                LockState: v.LockState,
                online: v.online,
                gateType: v.gateType,
                gateTypeShow: v.gateType,
                Url: '',
                Id: String(v.Id) + 0,
                Name: v.Name + '-' + 1,
                liveImages: [],
                isIframe: false,
              });
            }
          })
        })
      }
    },
    setVideo(obj) {
      if (this.settingConfig.ShowVideo === 2) {
        let imgObj = JSON.parse(this.liveImages);
        console.log('setVideo', imgObj);
        if (imgObj.inGateId === obj.GateId) {
          obj.liveImages = imgObj.passInFullImageArr
        }
        if (imgObj.outGateId === obj.GateId) {
          obj.liveImages = imgObj.passOutFullImageArr
        }
      }
      let arr = this.videoList.filter(val => {
        return val.Id === obj.Id
      })
      if (arr.length === 0 ){
        this.videoList.push(obj)
      }
      if (this.videoList.length >= this.gateId.length) {
        this.sortVideoArr();
      }
    },
    openFullScreen() {
      this.fullscreenLoading = true;
      this.getVideo();
      setTimeout(() => {
        this.fullscreenLoading = false;
      }, 2000);
    },
    showDialogHandleOutIn(key, gateId, direction) {
      this.videoGateId = gateId;
      if (key === 'showHandleOut'){
        this.$confirm("确定关闸?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          closeGate({OutGateId: gateId, Source: 2}).then(res => {
            if (res.state === "success") {
              this.$message.success(res.message);
              voicePrompt('一路平安');
            } else {
              this.$message.error(res.message);
            }
          })
        });
      } else {
        this[key] = true;
        this.direction = direction;
        // console.log(this.direction)
      }
    },
    async handleLock(GateId) {
      let res = await lockGate({ParkLotGateId: GateId});
      if (res.state === "success") {
        this.videoArr.forEach(v => {
          if (GateId === v.GateId) {
            v.LockState = 2;
          }
        });
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
    async handleUnLock(GateId) {
      let res = await unLockGate({ParkLotGateId: GateId});
      if (res.state === "success") {
        this.videoArr.forEach(v => {
          if (GateId === v.GateId) {
           v.LockState = 1;
          }
        });
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
    showDialogSearchTable(GateId) {
      parkOrderListPubSub.publish(GateId)
    },
    handleClose() {
      this.$store.dispatch("SetShowOrderImg", undefined);
    },
    sortVideoArr() {
      // console.log( this.videoList)
      this.videoArr = [];
      this.gateId.forEach(v => {
        let sameArr = this.videoList.filter(val => {
          return val.GateId === v.Id
        })
        // console.log(sameArr)
        this.videoArr = this.videoArr.concat(sameArr)
        // console.log(this.videoArr)
      });
    },
    handleBig(data) {
      this.videoData = data;
      this.showHandleVideo = true;
    },
    handleBigClose() {
      this.$refs[`video${this.videoData.Id}`].destroyPlayer();
      this.videoData = {
        Id: undefined,
        Url: undefined,
      };
      this.showHandleVideo = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.realtime-video-list {
  background: #fff;
  padding: 10px 20px 0;
  box-sizing: border-box;
  .header{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
}
.realtime-video-card-list {
  margin: auto;
  overflow-x: auto;
  >div{
    .box-card{
      float: left;
      width: 380px;
    }
  }
}
.box-card {
  background: rgba(94, 127, 236, 0.03);
  opacity: 1;
  padding: 0 10px;
  margin-right: 20px;
  & img {
    display: block;
    width: 100%;
    // max-width: 490px;
    max-height: 338px;
  }
}
.clearfix {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  opacity: 1;
}
</style>
<style lang="scss">
.unCollaps {
  display: flex;
  justify-content: flex-start;
  /*flex-direction: column;*/
  flex-wrap: wrap;
}
.isCollaps {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  & .realtime-video-card-list {
    height: 600px;
    text-align: center;
    & .el-card__body {
      // height: 600px;
      // &>div{
      //   height: 600px;
      // }
    }
  }
}
.box-card {
  border: none;
  & .el-card__header {
    background: rgba(94, 127, 236, 0.1);
    margin: 0 -10px;
    padding: 0 10px!important;
    & .clearfix{
      padding: 10px 0;
      > div:first-of-type{
        float: right;
        margin-top: 7px;
      }
      > div:last-of-type{
        text-align: left;
      }
    }
    & .type-list{
      display: flex;
      font-size: 12px;
      font-weight: normal;
      >div {
        display: flex;
        margin-top: 5px;
        margin-right: 15px;
        padding: 3px 0;
        border-radius: 2px;
        position: relative;
      }
      >div.offline{
        color: #F56C6C;
      }
      >div.offline:after{
        content: '';
        position: absolute;
        width: calc(100% + 10px);
        height: 100%;
        left: -5px;
        top: -1%;
        box-shadow: inset 0px 0px 6px 0px rgba(248, 37, 37, 0.5);
      }
    }
  }
  & .el-card__body {
    padding: 0;
    .video-box{
      height: 225px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .video{
        width: 100%;
      }
      p{
        line-height: 2;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #333333;
      }
      .gate-box{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  margin-bottom: 20px;
  & .video{
    & .videoElement{
      border-bottom: 5px dashed #fff;
    }
    & .videoElement:last-of-type{
      border-bottom: none;
    }
  }
}
  .noVideo{
    display: block;
    width: 300px;
    margin: auto;
    // transform: translate(-50%,-50%);
  }
  .nodata-container{
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
  .videoDialog{
    .videoElement{
      height: 615px;
    }
  }
</style>
